import { render, staticRenderFns } from "./Paciente.vue?vue&type=template&id=521c68c8&scoped=true"
import script from "./Paciente.vue?vue&type=script&lang=js"
export * from "./Paciente.vue?vue&type=script&lang=js"
import style0 from "./Paciente.vue?vue&type=style&index=0&id=521c68c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c68c8",
  null
  
)

export default component.exports